import { UsersEffects } from './users/users.effects';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { reducers } from './collections.reducer';
import { CandidateEffects } from './candidates/candidates.effects';
import { ProjectsEffects } from './projects/projects.effects';
import { NotesEffects } from './notes/notes.effects';
import { ChatbotEffects } from './chatbot/chatbot.effects';
import { CandidateDnaEffects } from './candidate-dna/candidate-dna.effects';
import { RolesThatFitEffects } from './roles-that-fit/roles-that-fit.effects';
export const effects = [
  CandidateEffects,
  ProjectsEffects,
  UsersEffects,
  NotesEffects,
  ChatbotEffects,
  CandidateDnaEffects,
  RolesThatFitEffects,
];

@NgModule({
  imports: [
    StoreModule.forFeature('collections', reducers),
    EffectsModule.forFeature([...effects]),
  ],
  providers: [...effects],
})
export class CollectionsModule {}
